/* global SUMMERNOTE_CONFIG, WebFont */ 
import PropTypes from 'prop-types';
import React from 'react';
import { intersection } from 'lodash';

export default class FontSearchBar extends React.Component {  
  static propTypes = {
    maxFontSearchListed: PropTypes.number,
    node: PropTypes.object,
    textarea: PropTypes.object
  }

  static defaultProps = {
    maxFontSearchListed: 10
  }

  constructor(props) {
    super(props);

    this.$textarea = $(props.textarea);
    this.$context = this.$textarea.siblings('.note-editor');
    this.$fontButton = this.$context.find('.note-fontname');
    this.$fontList = this.$context.find('.dropdown-fontname');
    this.$editor = this.$context.find('.note-editable');
    this.allFonts = SUMMERNOTE_CONFIG.fonts.default.concat(SUMMERNOTE_CONFIG.fonts.google);

    this.$fontButton.click(() => { this.fontButtonClicked() });
  }

  componentDidMount() {
    this.addSearchBar();
    this.loadFonts(this.$editor.find('font').map(function() { return $(this).attr('face') }));
    WebFont.load({ google: { families: ["Open Sans"] } });
  }

  fontButtonClicked = () => {
    this.props.node.summernote('editor.saveRange');
    this.clearFontList();
    this.addFontsToList(SUMMERNOTE_CONFIG.fonts.default);
    this.$fontList.find('input').val('');
  }

  loadFonts = (fonts) => {
    if (fonts.length === 0) { return; }
    let fontsToLoad = {};
    for (let key in SUMMERNOTE_CONFIG.fonts) {
      if (key === 'default') { continue; }
      const allFontsForService = SUMMERNOTE_CONFIG.fonts[key];
      const supportedFonts = intersection(allFontsForService, fonts);
      if (supportedFonts.length > 0) { fontsToLoad[key] = { "families": supportedFonts }; }
    }
    WebFont.load(fontsToLoad);
  }

  clearFontList = () => {
    this.$fontList.find('li:has(a[data-value])').remove()
  } 

  addFontsToList = (fontNames) => {
    if (fontNames.length === 0) { return; }
    fontNames.forEach((fontName) => {
      const html = $("<li><a href='#' data-value='"+fontName+"' style='font-family:"+fontName+"'>"+fontName+"</li>");
      html.click(() => { this.props.node.summernote('editor.restoreRange') });
      this.$fontList.append(html);
    });
    this.loadFonts(fontNames);
  }

  addSearchBar = () => {
    const html = $("<li><input type='text' class='summernote-font-search' placeholder='Search for more fonts'></input></li>");
    html.click(function(e) { e.stopPropagation() });
    html.keyup((e) => { this.search(e.target.value) });
    this.$fontList.append(html);
  }

  escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  search = (searchTerm) => {
    if (searchTerm === '') {
      this.clearFontList(); this.addFontsToList(SUMMERNOTE_CONFIG.fonts.default); return;
    }

    const reg = new RegExp(this.escapeRegExp(searchTerm), 'i');
    let matchedFonts = [];

    this.allFonts.some((font) => {
      if(matchedFonts.length >= this.props.maxFontSearchListed) { return true }
      if(reg.test(font)) { matchedFonts.push(font); }
    });

    this.clearFontList();
    this.addFontsToList(matchedFonts);
  }

  render() {
    return (<div />);
  }
}